module.exports = __webpack_public_path__ + "img/giraffestag.01bd9407.png";